import React, { Component } from "react";
import { findIndex } from "lodash";
import { Button, Modal } from "react-bootstrap";
import {
  TEXT_SAVE,
  TEXT_NO,
  MAX_WIDTH_SP,
  RING_SIZE_DEFAULT,
  RING_COLOR_DEFAULT
} from "../../const";
import DesignTool from "../../designtool";

export default class DialogConfirmTab extends Component {
  handleResetDesignTool() {
    let {
      ringIdClick,
      handleUpdateState,
      designInfo,
      getWidthBrowser,
      ringTypeList
    } = this.props;

    handleUpdateState("isShowDialogConfirmTab", false);
    handleUpdateState("isShowModalMaterial", true);
    handleUpdateState("idMaterialActive", 1);
    handleUpdateState("ringIdActive", ringIdClick);
    handleUpdateState("isResetDesign", true);

    //- Show tab on SP version
    if (MAX_WIDTH_SP > getWidthBrowser()) {
      handleUpdateState("isShowModalRingList", true);
      handleUpdateState("isShowPopupSp", true);
      handleUpdateState("isShowModalCategoryList", false);
      handleUpdateState("isShowModalFortuneList", false);
      handleUpdateState("isShowModalColorList", false);
    }

    //- Remove materials tray
    localStorage.setItem("materials", JSON.stringify([]));
    handleUpdateState("isUpdateMaterialsTray", true);

    // Update design tool
    DesignTool.clearItems();

    let indexItem = findIndex(ringTypeList, item => item.id === ringIdClick);

    //- Set default ring select
    if (indexItem !== -1) {
      let itemRing = ringTypeList[indexItem].rings[0];

      handleUpdateState("designInfo", {
        ringId: itemRing.id,
        ringSize: itemRing.sizes[0].size,
        ringSizeMin: DesignTool.getSizeDesignMin(designInfo),
        ringSizeMax: DesignTool.getSizeDesignMax(designInfo),
        ringColor: itemRing.colors[0].color_name,
        ringPrice: itemRing.price,
        ringColorCode: itemRing.colors[0].color_code
      });

      DesignTool.initializeDesign(
        ringIdClick,
        document.getElementById("wrap_draw_tool"),
        {
          size: itemRing.sizes[0].size,
          color: itemRing.colors[0].color_code
        },designInfo
      );

      return;
    }

    handleUpdateState("designInfo", {
      ringId: 0,
      ringSize: null,
      ringColor: "",
      ringPrice: 0,
      ringColorCode: RING_COLOR_DEFAULT
    });

    DesignTool.initialize(
      ringIdClick,
      document.getElementById("wrap_draw_tool"),
      {
        size: RING_SIZE_DEFAULT,
        color: RING_COLOR_DEFAULT
      }
    );
  }

  handleSaveDesign() {
    let { handleUpdateState } = this.props;

    handleUpdateState("isShowDialogConfirmTab", false);
    handleUpdateState("isSaveForTab", true);
    handleUpdateState("isShowDialogConfirmSave", true);
  }

  render() {
    let { isShowDialogConfirmTab, handleUpdateState } = this.props;

    return (
      <Modal
        show={isShowDialogConfirmTab}
        onHide={() => handleUpdateState("isShowDialogConfirmTab", false)}
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="dialog_custom modal_custom"
        centered
      >
        <Modal.Body>
          <button
            className="modal_close"
            onClick={() => handleUpdateState("isShowDialogConfirmTab", false)}
          >
            <img src="/img/icon_close_new.png" alt="" />
          </button>
          <span>このデザインを保存しますか？</span>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => this.handleResetDesignTool()}>
            {TEXT_NO}
          </Button>
          <Button variant="primary" onClick={() => this.handleSaveDesign()}>
            {TEXT_SAVE}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
